module.exports = __webpack_public_path__ + "static/media/placeholder-img-3.434b8ad4.png";